<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title style="font-weight: bold; font-size: 1.60em; margin-bottom: 3px">
        Error
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <div style="text-align: start; font-weight: bold">
            An error occurred while checking your registration status. Please try again later.
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'RegistrationError'
};
</script>
